import * as Yup from "yup";
import { PublicTransportImportType } from "../../../../constant/PublicTransportImportType";

export const triggerImportSchema = Yup.object().shape({
  type: Yup.number().required("Type is required"),
  atocFile: Yup.mixed().when("type", {
    is: (val: any) => Number(val) === PublicTransportImportType.AtocCif,
    then: (schema) => schema.required("Atoc File is required").nullable(),
    otherwise: (schema) => schema.nullable(),
  }),
  gtfsFile: Yup.mixed().when("type", {
    is: (val: any) => Number(val) === PublicTransportImportType.Gtfs,
    then: (schema) => schema.required("GTFS file is required").nullable(),
    otherwise: (schema) => schema.nullable(),
  }),
  quarter: Yup.string().when("type", {
    is: (val: any) => Number(val) === PublicTransportImportType.Gtfs,
    then: (schema) => schema.required("Quarter is required"),
    otherwise: (schema) => schema.nullable(),
  }),
  gtfsName: Yup.string().when("type", {
    is: (val: any) => Number(val) === PublicTransportImportType.Gtfs,
    then: (schema) => schema.required("Description is required"),
    otherwise: (schema) => schema.nullable(),
  }),
  ncsdFile: Yup.mixed().when("type", {
    is: (val: any) => Number(val) === PublicTransportImportType.NCSD,
    then: (schema) => schema.required("NCSD file is required").nullable(),
    otherwise: (schema) => schema.nullable(),
  }),
  busArchive: Yup.mixed().when("type", {
    is: (val: any) => Number(val) === PublicTransportImportType.Translink,
    then: (schema) => schema.required("Bus archive is required").nullable(),
    otherwise: (schema) => schema.nullable(),
  }),
  railArchive: Yup.mixed().when("type", {
    is: (val: any) => Number(val) === PublicTransportImportType.Translink,
    then: (schema) => schema.required("Rail archive is required").nullable(),
    otherwise: (schema) => schema.nullable(),
  }),
  metroArchive: Yup.mixed().when("type", {
    is: (val: any) => Number(val) === PublicTransportImportType.Translink,
    then: (schema) => schema.required("Metro archive is required").nullable(),
    otherwise: (schema) => schema.nullable(),
  }),
  usTransitImportId: Yup.string().when("type", {
    is: (val: any) => Number(val) === PublicTransportImportType.UsTransitMerge,
    then: (schema) => schema.required("USTransit Import ID is required"),
    otherwise: (schema) => schema.nullable(),
  }),
  transitLandImportId: Yup.string().when("type", {
    is: (val: any) => Number(val) === PublicTransportImportType.UsTransitMerge,
    then: (schema) => schema.required("Transitland Import ID is required"),
    otherwise: (schema) => schema.nullable(),
  }),
});
